import * as runtime from '@/api/runtime'
import {
  DeleteReserveSetRequest,
  DeleteReserveSetRequestToJSON,
  GetReserveSetRequest,
  GetReserveSetRequestToJSON,
  RegisterReserveSetRequest,
  RegisterReserveSetRequestToJSON,
  ReservationCandidateList,
  ReservationCandidateListFromJSON,
  ReserveSet,
  ReserveSetFromJSON,
  SearchReserveSetRequest,
  SearchReserveSetRequestToJSON,
  UpdateReserveSetRequest,
  UpdateReserveSetRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class ReserveSetApi extends runtime.BaseAPI {
  /**
   * セット予約候補リストを検索する
   * セット予約候補リスト検索
   */
  async searchSetReserve(
    request: SearchReserveSetRequest
  ): Promise<ReservationCandidateList[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchReserveSetRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/reserve-sets/search',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReservationCandidateListFromJSON)
    ).value()
  }

  /**
   * セット予約候補リストを取得する
   * セット予約候補リスト取得
   */
  async getSetReserve(request: GetReserveSetRequest): Promise<ReserveSet> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetReserveSetRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/reserve-sets/${queryParameters?.id ?? ''}`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReserveSetFromJSON(jsonValue)
    ).value()
  }

  /**
   * セット予約候補リストを削除する
   * セット予約候補リスト削除
   */
  async deleteSetReserve(
    request: DeleteReserveSetRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteReserveSetRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/reserve-sets/${bodyParameters?.id ?? ''}`
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * セット予約候補リストを登録する
   * セット予約候補リスト登録
   */
  async registerSetReserve(
    request: RegisterReserveSetRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = RegisterReserveSetRequestToJSON(
      request
    )
    const response = await this.requestPost('/reserve-sets', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * セット予約候補リストを更新する
   * セット予約候補リスト更新
   */
  async updateSetReserve(
    request: UpdateReserveSetRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateReserveSetRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/reserve-sets/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
